var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.6442 23.2018C22.0743 23.6319 22.7717 23.6319 23.2018 23.2018C23.6319 22.7717 23.6319 22.0743 23.2018 21.6442L21.6442 23.2018ZM17.0464 15.4889C16.6163 15.0588 15.919 15.0588 15.4889 15.4889C15.0588 15.919 15.0588 16.6163 15.4889 17.0464L17.0464 15.4889ZM17.2181 11.1382C17.2181 14.496 14.496 17.2181 11.1382 17.2181V19.4208C15.7126 19.4208 19.4208 15.7126 19.4208 11.1382H17.2181ZM11.1382 17.2181C7.78043 17.2181 5.05839 14.496 5.05839 11.1382H2.85567C2.85567 15.7126 6.5639 19.4208 11.1382 19.4208V17.2181ZM5.05839 11.1382C5.05839 7.78043 7.78043 5.05839 11.1382 5.05839V2.85567C6.5639 2.85567 2.85567 6.5639 2.85567 11.1382H5.05839ZM11.1382 5.05839C14.496 5.05839 17.2181 7.78043 17.2181 11.1382H19.4208C19.4208 6.5639 15.7126 2.85567 11.1382 2.85567V5.05839ZM23.2018 21.6442L17.0464 15.4889L15.4889 17.0464L21.6442 23.2018L23.2018 21.6442Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.605d6e720e5c5c6393f023a31d27b805.svg";
export { ForwardRef as ReactComponent };